import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode"; 
import { useTranslation } from "react-i18next"; 
import "./home.css";

function Home() {
  const { t, i18n } = useTranslation("backend");
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [totalUsers, setTotalUsers] = useState(null);
    const [todaylogins, setTodayLogins] = useState(null);
  const [totalSubscriptions, setTotalSubscriptions] = useState(null);
  const [totalUnpaid, setTotalUnpaid] = useState(null);
  const [totalExpiringUsers, setTotalExpiringUsers] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [totalActiveSubscriptions, setTotalActiveSubscriptions] = useState(0);
  const [totalSuspendedSubscriptions, setTotalSuspendedSubscriptions] =
    useState(0);
  const token = Cookies.get("token");
  let isAdmin = false;
  let userEmail = "";

  if (token) {
    const decodedToken = jwtDecode(token);
    isAdmin = decodedToken.isAdmin;
    userEmail = decodedToken.email;
  }

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        fetchTotalUsers(),
        fetchTotalSubscriptions(),
        fetchExpiringUsers(),
        fetchUnpaid(),
        fetchStatusSubscriptions(),
        !isAdmin && fetchExpiryDate(),
      ]);
    };

    fetchData();
  }, [isAdmin]);

  const fetchTotalUsers = async () => {
    try {
      const response = await fetch(`${BASE_URL}/total-users`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        const data = await response.json();
        setTotalUsers(data.total_users);
        setTodayLogins(data.today_logins);
      } else {
        console.error("Error fetching total users.");
      }
    } catch (err) {
      console.error("Error:", err.message);
    }
  };

  const fetchTotalSubscriptions = async () => {
    try {
      const response = await fetch(`${BASE_URL}/total-subscriptions`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        const data = await response.json();
        setTotalSubscriptions(data.total_subscriptions);
      } else {
        console.error("Error fetching total subscriptions.");
      }
    } catch (err) {
      console.error("Error:", err.message);
    }
  };

  const fetchStatusSubscriptions = async () => {
    try {
      const response = await fetch(`${BASE_URL}/subscriptions/status`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        const data = await response.json();
        setTotalActiveSubscriptions(data.total_active);
        setTotalSuspendedSubscriptions(data.total_suspended);
      } else {
        console.error("Error fetching total subscriptions.");
      }
    } catch (err) {
      console.error("Error:", err.message);
    }
  };

  const fetchUnpaid = async () => {
    try {
      const token = Cookies.get("token"); 
      let isAdmin = false;
      let userEmail = "";

      if (token) {
        const decodedToken = jwtDecode(token);
        isAdmin = decodedToken.isAdmin;
        userEmail = decodedToken.email;
      }

      let queryParams;

      if (isAdmin) {
        queryParams = new URLSearchParams({
          isAdmin: "true", 
        });
      } else {
        queryParams = new URLSearchParams({
          isAdmin: "false", 
          email: userEmail, 
        });
      }

      const response = await fetch(
        `${BASE_URL}/total-unpaid?${queryParams.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setTotalUnpaid(data.total_unpaid); 
        console.log("Unpaid Invoices:", data);
      } else {
        console.error("Error fetching unpaid invoices.");
      }
    } catch (err) {
      console.error("Error:", err.message);
    }
  };

  const fetchExpiringUsers = async () => {
    try {
      const response = await fetch(`${BASE_URL}/expiringUsers`, {
        method: "GET",
      });
      const result = await response.json();
      if (response.ok) {
        setTotalExpiringUsers(result.user_count);
      } else {
        console.error("Error fetching expiring users:", result.error);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchExpiryDate = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/subscriptionDetail/${userEmail}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();
      if (response.ok) {
        setSubscriptions(result.data);
        console.log("abc" + subscriptions);
      } else {
        console.error("Error fetching expiry date:", result.error);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  return (
    <section className="main1-container">
      <div className="main-title">
        <h3>{t("dashboard")}</h3>
      </div>

      <div className="main-cards">
        {isAdmin ? (
          <>
            <div className="card card-1">
              <div className="card-inner">
                <h3>{t("total_subscriptions")}</h3>
              </div>
              <h1>{totalSubscriptions}</h1>
            </div>

            <div className="card card-2">
              <div className="card-inner">
                <h3>{t("active_subscriptions")}</h3>
              </div>
              <h1>{totalActiveSubscriptions}</h1>
            </div>

            <div className="card card-3">
              <div className="card-inner">
                <h3>{t("suspeded_subscriptions")}</h3>
              </div>
              <h1>{totalSuspendedSubscriptions}</h1>
            </div>

            <div className="card card-4" style={{ cursor: "pointer" }}>
              <Link to="/dashboard/invoices" style={{ textDecoration: "none", color: "inherit" }}>
                <div className="card-inner" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <h3>{t("total_unpaid")}</h3>
                  <h1>{totalUnpaid}</h1>
                </div>
              </Link>
            </div>

            <div className="card card-5">
              <Link to="/dashboard/subscriptions" style={{ textDecoration: "none", color: "inherit" }}>
                <div className="card-inner">
                  <h3>{t("expiring_this")}</h3>
                </div>
                <h1>{totalExpiringUsers}</h1>
              </Link>
            </div>

            <div className="card card-6" >
              <div className="card-inner" style={{justifyContent:"center"}}>
                <h3>{t("total_users")}</h3>
              </div>
              <h1>{totalUsers}</h1>
            </div>
            <div className="card card-7" >
              <div className="card-inner" style={{justifyContent:"center",color:"grey"}}>
                <h3>{t("today_logins")}</h3>
              </div>
              <h1 style={{color:"grey"}}>{todaylogins}</h1>
            </div>

          </>
        ) : (
          <>
            <div className="card card-1">
              <div className="card-inner">
                <h3 style={{ textDecoration: "underline" }}>{t("product_subscribed")}</h3>
              </div>
            </div>

            <div className="card card-2" style={{ cursor: "pointer" }}>
              <Link to="/dashboard/invoices" style={{ textDecoration: "none", color: "inherit" }}>
                <div className="card-inner" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <h3>{t("total_unpaid")}</h3>
                  <h3>{totalUnpaid}</h3>
                </div>
              </Link>
            </div>

            <div className="card card-3">
              <div className="card-inner">
                <h3 style={{ textDecoration: "underline" }}>{t("expiry_date")}</h3>
              </div>
            </div>
          </>
        )}
      </div>

    </section>
  );
}

export default Home;
